import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(1.5)
  }
}));

export const ResourceMatchPopoverHeader = ({ resourceRequest }) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();

  return (
    <div className={classes.root}>
      <Typography data-qe-id="ResourceMatchPopover_Role" variant="h6">
        {resourceRequest.role?.displayText ||
          formatMessage({
            id: 'resourceMatchPopover.noRole'
          })}
      </Typography>
    </div>
  );
};

ResourceMatchPopoverHeader.propTypes = {
  resourceRequest: PropTypes.object.isRequired
};

export default ResourceMatchPopoverHeader;
